import * as cardsApi from '@/network/api/cards/cards.api.js'
import * as favoritesApi from '@/network/api/favorites.api.js'
import * as creditApi from '@/network/api/cards/credit.api.js'

/** requests Cards List
@return {promise} - Cards List request
*/
export const requestCardsList = async (context, payload) => {
	const res = await cardsApi.cards(payload)
	if (res) {
		const data = res.data.data
		context.commit('SAVE_CARDS_LIST', data)
	}
	return res
}

/** request Last Transfers list
@return {promise} - Last transfers List
*/
export const requestLastTransfersList = async (context, payload) => {
	const res = await creditApi.getPaymentsList(payload)
	if (res) {
		const data = res.data
		context.commit('SAVE_LAST_TRANSFERS', data)
	}
	return res
}

/** requests Favorites List
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_favoriteslist
@return {promise} - Favorites List
*/
export const requestFavoritesList = async (context, payload) => {
	const res = await favoritesApi.getFavoritesList(payload)

	if (res) {
		const data = res.data.data
		context.commit('SAVE_FAVORITES_LIST', { pageNumber: payload.pageNumber, data: data })
	}
	return res
}

/** Transfer Credit
@return {promise}
*/
export const creditTransfer = async (context, payload) => {
	const res = await creditApi.creditTopupTransfer(payload)
	return res
}

/* ***********************************************
*                   CLEAR ACTIONS                *
*********************************************** */
export const clearFeatureStates = async (context, payload) => {
	context.commit('CLEAR_FEATURE_STATE')
}
